import { TranslateModule } from './../../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { IonicModule } from '@ionic/angular';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ToolbarComponent, UserMenuComponent],
  imports: [
    CommonModule, IonicModule, RouterModule, TranslateModule
  ],
  entryComponents: [UserMenuComponent],
  exports: [ToolbarComponent]
})
export class ToolbarModule { }
